export default __webpack_public_path__ + "static/media/PicFix_Color logo.47bdc3f6.png";